import React, { useEffect, useState } from 'react'
import { Header, TemplateContainer } from 'components'
import { LoadingContainer, PageTemplate } from './styles'

import { FormUpdateConcacts } from 'components/Presenters/UpdateContacts'
import { BiometyDataType, ContactsBiometry, UpdateContactsInicialValues } from 'typings/unico'
import { UNICO_CONSTANTS } from 'redesign/constants'
import { useUnicoService } from 'services/unico'
import { useHistory } from 'react-router-dom'
import { ROUTES_PATH } from 'constants/routesPath'
import { Loading } from '@dasa-health/components-react'
import { getOrigin } from 'utils'
import { useTracking } from 'react-tracking'
import { useIsSafeURL } from 'redesign/hooks/useIsSafeURL'
import { SESSION_STORAGES_KEYS } from 'constants/sessionStorages'

const initialValues = {
    cellphone: '',
    email: '',
}

export const UpdateContactsUnico: React.FC = () => {
    const { createDraftFacialBiometryContacts } = useUnicoService()
    const [loading, setLoading] = useState(false)
    const [loadingCheckSessionStorageData, setLoadingCheckSessionStorageData] = useState(false)
    const history = useHistory()
    const { trackEvent } = useTracking()
    const { isSafeURL } = useIsSafeURL()

    const biometyDataLS: BiometyDataType = JSON.parse(sessionStorage.getItem(UNICO_CONSTANTS.STORAGE)!)
    const userRedirectUrl = biometyDataLS?.userRedirectUrl

    async function handleSubmit({ cellphone, email }: UpdateContactsInicialValues) {
        setLoading(true)

        const contacts = {
            email: email,
            cellphone: cellphone,
        } as ContactsBiometry

        try {
            await createDraftFacialBiometryContacts(contacts, biometyDataLS?.id!)

            trackEventSuccess(cellphone!, email!)
            sessionStorage.setItem(SESSION_STORAGES_KEYS.CONTACTS_BIOMETRY, JSON.stringify({ email, cellphone }))

            if (isSafeURL(userRedirectUrl!)) {
                window.open(userRedirectUrl, '_self')
            }
        } catch (error) {
            console.error(error)
            setLoading(false)
        }
    }

    function trackEventPage() {
        trackEvent({
            event: 'funnel_step',
            funnel: {
                name: getOrigin(biometyDataLS.origin),
                current_step: 'Adicionar contato',
                origin: getOrigin(biometyDataLS.origin),
            },
        })
    }

    function trackEventSuccess(cellphone: string, email: string) {
        const dadosPreenchidos = `${cellphone && 'telefone'}${email && ', email'}`

        trackEvent({
            event: 'funnel_step',
            funnel: {
                name: 'Reconhecimento Facial',
                current_step: `Contatos preenchidos | ${dadosPreenchidos}`,
                origin: getOrigin(biometyDataLS.origin!),
            },
        })
    }

    function redirectToLogin() {
        history.push(ROUTES_PATH.SIGN_IN)
    }

    function checkSessionStorageData() {
        setLoadingCheckSessionStorageData(true)
        if (biometyDataLS?.federalTaxId && biometyDataLS?.id && biometyDataLS?.origin) {
            trackEventPage()
            setLoadingCheckSessionStorageData(false)
            return
        }

        redirectToLogin()
    }

    useEffect(() => {
        checkSessionStorageData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return loadingCheckSessionStorageData ? (
        <LoadingContainer>
            <Loading />
        </LoadingContainer>
    ) : (
        <TemplateContainer>
            <PageTemplate>
                <Header
                    subtitle="Preencha pelo menos um contato válido para facilitar o próximo acesso."
                    title="Qual contato deseja adicionar?"
                />
                <FormUpdateConcacts handleSubmit={handleSubmit} initialValues={initialValues} isSubmitting={loading} />
            </PageTemplate>
        </TemplateContainer>
    )
}
